import { Checkbox, Modal, Text } from "@modernatx/ui-kit-react";
import React, { useState } from "react";

interface ExternalLinkModalProps {
  isOpen: boolean;
  setShowExternalLinkModal: React.Dispatch<React.SetStateAction<boolean>>;
  externalLink: string;
}

const ExternalLinkModal: React.FC<ExternalLinkModalProps> = ({
  isOpen,
  setShowExternalLinkModal,
  externalLink
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  const openExternalLink = () => {
    window.open(externalLink, "_blank");
    if (isChecked) {
      localStorage.setItem("dontRemindMeExternal", "true");
    }
    setShowExternalLinkModal(false);
    setIsChecked(false);
  };

  const handleCancel = () => {
    setShowExternalLinkModal(false);
    setIsChecked(false);
  };
  const modalButtons = [
    {
      label: "Cancel",
      onClick: handleCancel
    },
    {
      label: "Continue",
      onClick: openExternalLink
    }
  ];

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onDismiss={() => setShowExternalLinkModal(false)}
      buttons={modalButtons}
    >
      <Text variant="h5" sx={{ mb: "spacing-8" }}>
        You are now leaving Moderna Direct. The intended use and audience for
        the linked website may differ.
      </Text>
      <Checkbox
        id="checkbox-default"
        label="Don’t remind me again"
        value={isChecked}
        onChange={handleChange}
      />
    </Modal>
  );
};

export default ExternalLinkModal;
